'use client';

import { useState } from 'react';
import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from '@repo/ui/components/ui/alert-dialog';
import { Lock } from 'lucide-react';
import { UpgradePlanDialog } from './upgrade-plan-dialog';

interface FreeRestrictionDialogProps {
  open: boolean;
  onClose: () => void;
  featureName: string;
}

export function FreeRestrictionDialog({
  open,
  onClose,
  featureName,
}: FreeRestrictionDialogProps) {
  const [upgradeOpen, setUpgradeOpen] = useState(false);

  function handleViewOffers(): void {
    onClose();
    setUpgradeOpen(true);
  }

  return (
    <>
      <AlertDialog open={open} onOpenChange={(isOpen) => { if (!isOpen) onClose(); }}>
        <AlertDialogContent className="border-border/60 bg-card shadow-xl ring-2 ring-border/20 dark:border-border/80 dark:ring-border/30">
          <AlertDialogHeader className="space-y-3">
            <div className="flex items-center gap-2">
              <Lock className="h-5 w-5 text-destructive" aria-hidden="true" />
              <AlertDialogTitle className="text-xl font-semibold leading-tight text-foreground">
                Accès limité — Forfait gratuit
              </AlertDialogTitle>
            </div>
            <AlertDialogDescription className="text-sm leading-relaxed text-muted-foreground">
              L&apos;accès à <strong>{featureName}</strong> n&apos;est pas disponible avec le forfait
              gratuit. Souscrivez un abonnement pour débloquer cette fonctionnalité.
            </AlertDialogDescription>
          </AlertDialogHeader>
          <AlertDialogFooter className="gap-3 sm:gap-2.5">
            <AlertDialogCancel
              onClick={onClose}
              className="h-10 border-border/60 bg-background px-4 text-sm font-semibold"
            >
              Fermer
            </AlertDialogCancel>
            <AlertDialogAction
              onClick={handleViewOffers}
              className="h-10 bg-primary px-4 text-sm font-semibold text-primary-foreground"
            >
              Voir les offres
            </AlertDialogAction>
          </AlertDialogFooter>
        </AlertDialogContent>
      </AlertDialog>

      <UpgradePlanDialog
        open={upgradeOpen}
        onClose={() => setUpgradeOpen(false)}
      />
    </>
  );
}
